export { default } from './GridPlaces.vue'
